import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { Fragment, useState } from 'react';
import { PmiBodyTableCell } from 'shell/components/shared/table-custom/body';
import { PmiHeadTableCell } from 'shell/components/shared/table-custom/head';
import { PmiTableRow } from 'shell/components/shared/table/row';
import { PersonVM } from '.';

interface HistorianPeopleTableProps {
  people: PersonVM[];
}

const HistorianPeopleTable = ({ people = [] }: HistorianPeopleTableProps): React.ReactElement => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const rowsPerPageOptions = [5, 10, 20, 50];

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  return (
    <Fragment>
      <TableContainer>
        <Table sx={{ minWidth: 900 }} size="medium" stickyHeader aria-label="lista soggetti">
          <TableHead>
            <TableRow>
              <PmiHeadTableCell>Num. Fam.</PmiHeadTableCell>
              <PmiHeadTableCell>Cognome e nome</PmiHeadTableCell>
              <PmiHeadTableCell>Data di nascita</PmiHeadTableCell>
              <PmiHeadTableCell>Comune Nascita</PmiHeadTableCell>
              <PmiHeadTableCell>Data Reg.</PmiHeadTableCell>
              <PmiHeadTableCell>Motivo</PmiHeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {people.slice(startIndex, endIndex).map((person, i) => (
              <PmiTableRow key={i.toString()}>
                <PmiBodyTableCell id={`${i}-familyNumber`} scope="row">
                  {person.familyNumber}
                </PmiBodyTableCell>
                <PmiBodyTableCell id={`${i}-surnameName`} scope="row">
                  {person.surnameName}
                </PmiBodyTableCell>
                <PmiBodyTableCell id={`${i}-birthday`} scope="row">
                  {person.birthday}
                </PmiBodyTableCell>
                <PmiBodyTableCell id={`${i}-birthplace`} scope="row">
                  {person.birthplace}
                </PmiBodyTableCell>
                <PmiBodyTableCell id={`${i}-regDate`} scope="row">
                  {person.regDate}
                </PmiBodyTableCell>
                <PmiBodyTableCell id={`${i}-reason`} scope="row">
                  {person.reason}
                </PmiBodyTableCell>
              </PmiTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        labelRowsPerPage="Righe per pagina:"
        count={people.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event: unknown, newPage: number) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
        }}
      />
    </Fragment>
  );
};

HistorianPeopleTable.displayName = 'Tabella indirizzi residenza in Italia';

export default HistorianPeopleTable;
